module.exports = __webpack_public_path__ + "static/media/envelope-gray.9a9d5656.svg";